module.exports = __webpack_public_path__ + "img/dask-zorunlu-deprem-sigortasi.823e5a12.svg";